import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'decimal',
    standalone: false
})
export class CustomDecimalPipe implements PipeTransform {
  transform(value: number, places: number): any {
    if (isNaN(value)) {
      value = 0;
    }
    return Number((Math.round(value * Math.pow(10, places)) / Math.pow(10, places)).toFixed(places)).toLocaleString('tr-TR');
  }
}
